const VERSION = "9.0.6";
export {
  VERSION
};
